import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'reactstrap';
import NotificationItem from './NotificationItem/NotificationItem';
import style from './Notifications.style';
import { clone } from '../../../../../Services/schedule';
// AlertProvider removed, using toast instead
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DepartmentContext } from '../../../../../DepartmentWrapper';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { fetchDataAgnostic } from '../../../../../Services/dataApi';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import AddNotificationModal from './AddNotificationModal/AddNotificationModal';
import EditNotificationModal from './EditNotificationModal/EditNotificationModal';

const fakeData = [
  {
    pk_Notification: 0,
    minutes: 12,
    when: 'end_of_meeting', // end_of_passing, end_of_meeting
    alertEvaluator: true,
    alertCandidate: false,
    notifEndsMeeting: false,
    message: 'BRUH WAKE UP MEETING ENDING',
    sound: 'Bell', //Bell, silent
  },
  {
    pk_Notification: 1,
    minutes: 5,
    when: 'end_of_passing', // end_of_passing, end_of_meeting
    alertEvaluator: true,
    alertCandidate: true,
    notifEndsMeeting: true,
    message: 'Block ending!',
    sound: 'Bell', //Bell, silent
  },
  {
    pk_Notification: 2,
    minutes: 1,
    when: 'end_of_meeting', // end_of_passing, end_of_meeting
    alertEvaluator: false,
    alertCandidate: true,
    notifEndsMeeting: false,
    message: 'Warning, last 60 seconds!',
    sound: 'silent', //Bell, silent
  },
];

// AlertTemplate removed - using toast instead

const Notifications = (props) => {
  const { windowWidth } = props;

  const [notifications, setNotifications] = useState([]);
  const [editableNotifications, setEditableNotifications] = useState([]);
  const [showAddNotificationModal, setShowAddNotificationModal] = useState(false);

  const { getTokenSilently, loginWithRedirect } = useAuth0();

  const dContext = useContext(DepartmentContext);

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    setEditableNotifications(notifications.slice());
  }, [notifications]);

  const getNotifications = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/alerts',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setNotifications(res.data || []);
            // setInterviewDates(res.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const updateNotification = (newNotif, index) => {
    const newNotifs = clone(notifications);
    newNotifs[index] = newNotif;
    setEditableNotifications(newNotifs);
  };

  const deleteNotification = (index) => {
    const newNotifs = clone(notifications);
    const notifToDelete = clone(newNotifs[index]);
    newNotifs.splice(index, 1);
    setEditableNotifications(newNotifs);
  };

  const renderAddNotificationModal = () => {
    return (
      <Modal isOpen={showAddNotificationModal} centered={true} style={{ maxWidth: '60%' }}>
        <ModalHeader
          closeButton
          toggle={() => {
            setShowAddNotificationModal(!showAddNotificationModal);
          }}
        >
          Add New Notification
        </ModalHeader>
        <ModalBody>
          <AddNotificationModal
            getNotifications={getNotifications}
            setShowAddNotificationModal={setShowAddNotificationModal}
          />
        </ModalBody>
      </Modal>
    );
  };

  const renderNotifHeader = () => {
    if (windowWidth < 680) {
      return (
        <div
          style={{
            ...style.simpleRow,
            // marginBottom: 10,
            padding: 10,
            backgroundColor: 'var(--rr-surface)',
            fontWeight: 'bold',
          }}
        >
          <div style={{ ...style.simpleColumn, width: 50, textAlign: 'center' }}></div>
          <div style={{ ...style.simpleColumn, width: 'calc(100% - 80px)', textAlign: 'center' }}>Alert </div>

          <div style={{ ...style.simpleColumn, width: 80, textAlign: 'center' }}>Action</div>
        </div>
      );
    }
    return (
      <div
        style={{
          ...style.simpleRow,
          // marginBottom: 10,
          padding: 10,
          backgroundColor: 'var(--rr-surface)',
          fontWeight: 'bold',
        }}
      >
        <div style={{ ...style.simpleColumn, width: 50, textAlign: 'center' }}></div>
        <div style={{ ...style.simpleColumn, width: '40%', textAlign: 'center' }}>Alert Message</div>
        <div style={{ ...style.simpleColumn, width: '15%', marginRight: 10, textAlign: 'center' }}>Alert Evaluator</div>
        <div style={{ ...style.simpleColumn, width: '15%', marginRight: 10, textAlign: 'center' }}>Alert Candidate</div>
        <div style={{ ...style.simpleColumn, width: '20%', textAlign: 'center' }}>Action</div>
      </div>
    );
  };

  return (
    <div style={style.simpleRow}>
      <div style={style.simpleColumn}>
        <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
          <div style={{ ...style.simpleColumn, width: windowWidth < 800 ? '100%' : '70%' }}>
            {editableNotifications && editableNotifications.length > 0 ? renderNotifHeader() : null}
          </div>
        </div>
        <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
          <div
            style={{
              ...style.simpleColumn,
              width: windowWidth < 800 ? '100%' : '70%',
              height: '60vh',
              overflowY: 'scroll',
            }}
          >
            {editableNotifications && editableNotifications.length > 0 ? (
              editableNotifications.map((n, i) => {
                return (
                  <NotificationItem
                    windowWidth={windowWidth}
                    notification={n}
                    index={i}
                    updateNotification={updateNotification}
                    deleteNotification={deleteNotification}
                    getNotifications={getNotifications}
                  />
                );
              })
            ) : (
              <div style={{ ...style.simpleRow, justifyContent: 'center', height: '100%', alignItems: 'center' }}>
                No Notifications
              </div>
            )}
          </div>
        </div>
        <div style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <Button
            style={{ width: 200 }}
            color="success"
            onClick={() => {
              setShowAddNotificationModal(true);
              // saveNotifs();
            }}
          >
            Add Notification
          </Button>
           
        </div>
      </div>
      {renderAddNotificationModal()}
    </div>
  );
};
export default Notifications;
